/**
 * Contador global de requisições em andamento.
 *
 * Playbook § Feedback e progresso: a barra ambiente do topo é movida por um
 * estado compartilhado lido com `useSyncExternalStore` — zero prop-drilling de
 * "loading". Qualquer camada (http client, ação de botão) apenas incrementa e
 * decrementa; nenhum componente precisa saber quem disparou o quê.
 */

let pending = 0;
const listeners = new Set<() => void>();

function emit() {
  listeners.forEach((listener) => listener());
}

export function beginRequest(): void {
  pending += 1;
  emit();
}

export function endRequest(): void {
  pending = Math.max(0, pending - 1);
  emit();
}

/** Envolve uma promise no contador, mesmo em caso de erro. */
export async function trackRequest<T>(run: () => Promise<T>): Promise<T> {
  beginRequest();
  try {
    return await run();
  } finally {
    endRequest();
  }
}

export function subscribePending(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function getPendingCount(): number {
  return pending;
}

/** Só para testes: zera o contador entre cenários. */
export function resetPending(): void {
  pending = 0;
  emit();
}
